<template>
  <nav class="navbar nav-bottom">
    <div class="container-fluid">
      <router-link v-if="links" class="link" id="previous" v-bind:to="previousLink">Previous Page</router-link>
      <a class="link return" v-on:click="scrollToTop()">Return to Top</a> 
      <router-link v-if="links" class="link" id="next" v-bind:to="nextLink">Next Page</router-link> 
    </div>
  </nav>
</template>

<script>

export default {
  name: 'BottomNavbar',
  props:{
      color:String,
      links:Array
  },
  mounted(){
    this.setLinks(); 
    this.setColor();
  },
  updated(){
    this.setColor();
    this.setLinks();     
  },
  data(){
    return{
      nextLink:"",
      previousLink:"",
    }
  },
  methods:{
    scrollToTop(){
       window.scrollTo(0,0);
    },
    convertColor(hexCode, opacity){
        var hex = hexCode.replace('#', '');

        if (hex.length === 3) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }

        var r = parseInt(hex.substring(0,2), 16),
            g = parseInt(hex.substring(2,4), 16),
            b = parseInt(hex.substring(4,6), 16);

        /* Backward compatibility for whole number based opacity values. */
        if (opacity > 1 && opacity <= 100) {
            opacity = opacity / 100;   
        }
        
        return 'rgba('+r+','+g+','+b+','+opacity+')';
    },
    setColor(){
      var background = this.convertColor(this.color, 0.5);
    
      document.querySelector(".nav-bottom").style.borderLeft = "20px solid" + this.color;
      document.querySelector(".nav-bottom").style.background = background;
    },
    setLinks(){
      if (this.links){
        var page = this.$route.params.mappage,
          links = this.links;
      
        for (var i = 0; i < links.length; i++){
          if (links[i].href == page){
            if (i == (links.length - 1)){
              this.nextLink = "/home";
              this.previousLink = links[i-1].href;
            }
            else{
              this.nextLink = links[i+1].href;
              if (i == 0){
                this.previousLink = "/home";
              }
              else{
                this.previousLink = links[i-1].href;
              }
            }
          }
        }
      }
      else{
        document.querySelector('.return').style.margin = "auto";
      }
    }
  }
}
</script>

<style>
    .nav-bottom{
        padding: 0 !important;
        height:50vh;
    }
    .return:hover{
      cursor:pointer;
    }
</style>
